import { Component, OnInit, signal, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface CarouselCard {
  id: number;
  title: string;
  value: string;
  icon: string;
  description: string;
  theme: string;
  bgGradient?: string;
}

@Component({
  selector: 'app-feature-carousel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './feature-carousel.component.html',
  styleUrls: ['./feature-carousel.component.scss']
})
export class FeatureCarouselComponent implements OnInit {
  
  @Input() autoplaySpeed = 40; 
  @Input() pauseOnHover = true;

  isPaused = signal(false);

  cards: CarouselCard[] = [
    {
      id: 2,
      title: '',
      value: 'Trabajador',
      icon: 'assets/images/pngs/trabajador.png',
      description: 'Personal registrado',
      theme: 'emerald',
      bgGradient: 'from-emerald-500 to-teal-500'
    },
    {
      id: 3,
      title: '',
      value: 'Planilla',
      icon: 'assets/images/pngs/planilla2.png',
      description: 'Procesos de planilla en curso',
      theme: 'purple',
      bgGradient: 'from-purple-500 to-pink-500'
    },
    {
      id: 4,
      title: '',
      value: 'Contabilidad',
      icon: 'assets/images/svgs/contabilidad1.png',
      description: 'Eventos programados',
      theme: 'orange',
      bgGradient: 'from-orange-500 to-amber-500'
    },
    {
      id: 5,
      title: '',
      value: 'Equipo',
      icon: 'assets/images/svgs/equipo3.png',
      description: 'Nómina mensual procesada',
      theme: 'pink',
      bgGradient: 'from-pink-500 to-rose-500'
    },
    {
      id: 6,
      title: '',
      value: 'Configuración',
      icon: 'assets/images/pngs/configuracion2.png',
      description: 'Configuración generada este mes',
      theme: 'cyan',
      bgGradient: 'from-cyan-500 to-blue-500'
    },
    {
      id: 7,
      title: '',
      value: 'Administración',
      icon: 'assets/images/svgs/administracion1.png',
      description: 'Gestión de nóminas mensuales',
      theme: 'indigo',
      bgGradient: 'from-indigo-500 to-purple-500'
    }
  ];

  get infiniteCards(): CarouselCard[] {
    return [...this.cards, ...this.cards, ...this.cards];
  }

  ngOnInit(): void {
  }

  onMouseEnter(): void {
    if (this.pauseOnHover) {
      this.isPaused.set(true);
    }
  }

  onMouseLeave(): void {
    this.isPaused.set(false);
  }
}
